import React, { useState } from 'react';
import styles from './Careers.module.css';

const Careers = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [showApplyModal, setShowApplyModal] = useState(false);

  // Dummy vacancies data
  const vacancies = [
    {
      id: 1,
      title: "Senior Mathematics Faculty (UPSC Optional)",
      department: "Academics",
      location: "Delhi / Remote",
      experience: "5+ years",
      type: "Full Time",
      status: "active",
      postedDate: "2026-02-11",
      closingDate: "2026-03-11",
      description: "We are looking for an experienced Mathematics faculty member to lead our UPSC Mathematics Optional batch. The ideal candidate should have deep expertise in Real Analysis, Linear Algebra, and Calculus.",
      responsibilities: [
        "Take live online/offline classes for UPSC Mathematics Optional",
        "Develop comprehensive study material and test series",
        "Mentor students through doubt clearing sessions",
        "Create answer writing strategies for mains",
        "Evaluate test copies with detailed feedback"
      ],
      requirements: [
        "Master's or Ph.D in Mathematics from reputed institution",
        "5+ years of teaching experience for UPSC/BPSC Mathematics Optional",
        "Excellent communication and presentation skills",
        "Experience with online teaching platforms",
        "Previous rank holders preferred"
      ],
      perks: [
        "Competitive salary + Performance bonus",
        "Flexible working hours",
        "Opportunity to work with top educators",
        "Annual retreats and workshops"
      ],
      googleFormUrl: "https://forms.gle/dummy1",
      applicants: 45
    },
    {
      id: 2,
      title: "Academic Content Developer (Mathematics)",
      department: "Content",
      location: "Patna / Remote",
      experience: "2-4 years",
      type: "Full Time",
      status: "active",
      postedDate: "2026-02-10",
      closingDate: "2026-03-10",
      description: "We are seeking a detail-oriented Content Developer to create high-quality study materials, practice questions, and test series for Mathematics Optional aspirants.",
      responsibilities: [
        "Develop chapter-wise study notes and PDFs",
        "Create practice questions and mock tests",
        "Review and update existing content",
        "Ensure error-free and exam-oriented material",
        "Collaborate with faculty for content improvement"
      ],
      requirements: [
        "Master's in Mathematics with minimum 60% marks",
        "2+ years of experience in educational content development",
        "Strong grasp of UPSC/BPSC Mathematics syllabus",
        "Proficiency in LaTeX and mathematical typesetting",
        "Attention to detail and deadline oriented"
      ],
      perks: [
        "Work from home flexibility",
        "Performance-based incentives",
        "Learning and development opportunities",
        "Young and dynamic team culture"
      ],
      googleFormUrl: "https://forms.gle/dummy2",
      applicants: 28
    },
    {
      id: 3,
      title: "Student Success Manager",
      department: "Operations",
      location: "Remote",
      experience: "1-3 years",
      type: "Full Time",
      status: "active",
      postedDate: "2026-02-12",
      closingDate: "2026-03-12",
      description: "We are hiring a Student Success Manager to ensure our learners have the best experience throughout their preparation journey with Exademy.",
      responsibilities: [
        "Onboard new students and guide them through courses",
        "Address student queries and concerns promptly",
        "Coordinate with faculty for doubt sessions",
        "Track student progress and engagement",
        "Collect feedback and improve learning experience"
      ],
      requirements: [
        "Bachelor's degree in any discipline",
        "1-3 years of experience in customer success or operations",
        "Excellent communication and interpersonal skills",
        "Empathetic and problem-solving attitude",
        "Experience in ed-tech industry preferred"
      ],
      perks: [
        "Competitive salary + ESOPs",
        "Health insurance coverage",
        "Fast career growth",
        "Fun team outings and celebrations"
      ],
      googleFormUrl: "https://forms.gle/dummy3",
      applicants: 52
    },
    {
      id: 4,
      title: "Business Development Associate",
      department: "Sales & Marketing",
      location: "Bhagalpur",
      experience: "0-2 years",
      type: "Full Time",
      status: "closed",
      postedDate: "2026-01-05",
      closingDate: "2026-01-31",
      description: "We were looking for enthusiastic sales professionals to expand our reach in Bihar region and help aspirants find the right guidance.",
      responsibilities: [
        "Generate leads through various channels",
        "Counsel students and parents about courses",
        "Achieve monthly sales targets",
        "Maintain CRM and track conversions",
        "Participate in campus events and seminars"
      ],
      requirements: [
        "Bachelor's degree in any field",
        "0-2 years of sales experience",
        "Strong persuasion and negotiation skills",
        "Fluent in Hindi and English",
        "Willingness to travel within Bihar"
      ],
      perks: [
        "Attractive incentive structure",
        "Fuel allowance",
        "Mobile reimbursement",
        "Monthly recognition awards"
      ],
      googleFormUrl: "",
      applicants: 67,
      reasonClosed: "Position filled"
    },
    {
      id: 5,
      title: "Graphic Designer (Educational Content)",
      department: "Creative",
      location: "Remote",
      experience: "1-3 years",
      type: "Contract",
      status: "closed",
      postedDate: "2026-01-10",
      closingDate: "2026-02-10",
      description: "We were seeking a creative Graphic Designer to create visually appealing educational graphics, infographics, and presentation materials for our courses.",
      responsibilities: [
        "Design course thumbnails and promotional creatives",
        "Create infographics for mathematical concepts",
        "Design presentation templates for faculty",
        "Edit video thumbnails for YouTube lectures",
        "Maintain brand consistency across designs"
      ],
      requirements: [
        "Proficiency in Adobe Creative Suite",
        "1-3 years of graphic design experience",
        "Portfolio demonstrating educational design work",
        "Understanding of typography and color theory",
        "Ability to work on tight deadlines"
      ],
      perks: [
        "Freelance to full-time conversion",
        "Flexible working hours",
        "Creative freedom",
        "Work with a passionate team"
      ],
      googleFormUrl: "",
      applicants: 94,
      reasonClosed: "Position on hold"
    }
  ];

  const activeJobs = vacancies.filter(job => job.status === 'active');
  const closedJobs = vacancies.filter(job => job.status === 'closed');

  const handleApplyClick = (job) => {
    if (job.status === 'active') {
      setSelectedJob(job);
      setShowApplyModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowApplyModal(false);
    setSelectedJob(null);
  };

  const openGoogleForm = (url) => {
    window.open(url, '_blank');
    handleCloseModal();
  };

  return (
    <div className={styles.careersPage}>
      {/* Header Section */}
      <div className={styles.careersHeader}>
        <div className={styles.container}>
          <h1>Shape the future of <span className={styles.gradientText}>Mathematics Education</span></h1>
          <p>Join our mission to empower 100,000+ aspirants to crack UPSC and State PSC examinations with Mathematics Optional.</p>
        </div>
        <div className={styles.headerWave}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120">
            <path fill="#EDFFF7" fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"></path>
          </svg>
        </div>
      </div>

      <div className={styles.container}>
        {/* Actively Hiring Section */}
        <div className={styles.sectionHeader}>
          <h2>Actively Hiring <span className={styles.activeCount}>({activeJobs.length})</span></h2>
          <p className={styles.sectionSubtitle}>Join our growing team and make an impact</p>
        </div>

        <div className={styles.jobsGrid}>
          {activeJobs.map((job) => (
            <div key={job.id} className={styles.jobCard}>
              <div className={styles.jobCardHeader}>
                <div className={styles.jobTitleSection}>
                  <h3 className={styles.jobTitle}>{job.title}</h3>
                  <span className={styles.jobStatusActive}>
                    <span className={styles.pulseDot}></span>
                    Actively Hiring
                  </span>
                </div>
                <div className={styles.jobMeta}>
                  <span className={styles.jobDepartment}>{job.department}</span>
                  <span className={styles.jobType}>{job.type}</span>
                </div>
              </div>

              <div className={styles.jobDetails}>
                <div className={styles.jobDetailItem}>
                  <i className="fas fa-map-marker-alt"></i>
                  <span>{job.location}</span>
                </div>
                <div className={styles.jobDetailItem}>
                  <i className="fas fa-briefcase"></i>
                  <span>{job.experience}</span>
                </div>
                <div className={styles.jobDetailItem}>
                  <i className="fas fa-calendar-alt"></i>
                  <span>Posted: {new Date(job.postedDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                </div>
              </div>

              <p className={styles.jobDescription}>{job.description}</p>

              <div className={styles.jobSections}>
                <div className={styles.jobSection}>
                  <h4>Key Responsibilities</h4>
                  <ul>
                    {job.responsibilities.slice(0, 3).map((item, idx) => (
                      <li key={idx}><i className="fas fa-check-circle"></i> {item}</li>
                    ))}
                  </ul>
                </div>

                <div className={styles.jobSection}>
                  <h4>Requirements</h4>
                  <ul>
                    {job.requirements.slice(0, 3).map((item, idx) => (
                      <li key={idx}><i className="fas fa-check-circle"></i> {item}</li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className={styles.jobFooter}>
                <div className={styles.applicantsInfo}>
                  <i className="fas fa-users"></i>
                  <span>{job.applicants} applicants</span>
                </div>
                <div className={styles.jobActions}>
                  <span className={styles.closingDate}>Closes: {new Date(job.closingDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                  <button 
                    className={styles.applyBtn}
                    onClick={() => handleApplyClick(job)}
                  >
                    <i className="fas fa-paper-plane"></i>
                    Apply Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Hiring Closed Section */}
        <div className={styles.sectionHeader}>
          <h2>Hiring Closed <span className={styles.closedCount}>({closedJobs.length})</span></h2>
          <p className={styles.sectionSubtitle}>These positions are currently not accepting applications</p>
        </div>

        <div className={styles.closedJobsGrid}>
          {closedJobs.map((job) => (
            <div key={job.id} className={styles.closedJobCard}>
              <div className={styles.closedJobHeader}>
                <div className={styles.jobTitleSection}>
                  <h3 className={styles.jobTitle}>{job.title}</h3>
                  <span className={styles.jobStatusClosed}>
                    <i className="fas fa-clock"></i>
                    {job.reasonClosed || 'Hiring Closed'}
                  </span>
                </div>
                <div className={styles.jobMeta}>
                  <span className={styles.jobDepartment}>{job.department}</span>
                  <span className={styles.jobType}>{job.type}</span>
                </div>
              </div>

              <div className={styles.jobDetails}>
                <div className={styles.jobDetailItem}>
                  <i className="fas fa-map-marker-alt"></i>
                  <span>{job.location}</span>
                </div>
                <div className={styles.jobDetailItem}>
                  <i className="fas fa-briefcase"></i>
                  <span>{job.experience}</span>
                </div>
                <div className={styles.jobDetailItem}>
                  <i className="fas fa-calendar-alt"></i>
                  <span>Closed: {new Date(job.closingDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                </div>
              </div>

              <div className={styles.closedJobFooter}>
                <div className={styles.applicantsInfo}>
                  <i className="fas fa-users"></i>
                  <span>{job.applicants} total applicants</span>
                </div>
                <button className={styles.closedBtn} disabled>
                  <i className="fas fa-ban"></i>
                  Applications Closed
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Why Join Us Section - Simplified */}
        <div className={styles.whyJoinSection}>
          <div className={styles.sectionHeaderCenter}>
            <span className={styles.sectionSup}>WHY EXADEMY</span>
            <h2>More than just a <span className={styles.gradientText}>job</span></h2>
          </div>

          <div className={styles.perksGrid}>
            <div className={styles.perkCard}>
              <div className={styles.perkIcon}>🚀</div>
              <h3>Fast Growth</h3>
              <p>Double-digit growth every quarter with ample opportunities for career advancement</p>
            </div>
            <div className={styles.perkCard}>
              <div className={styles.perkIcon}>💻</div>
              <h3>Remote First</h3>
              <p>Work from anywhere in India. Flexible hours focused on output, not clock-in time</p>
            </div>
            <div className={styles.perkCard}>
              <div className={styles.perkIcon}>📚</div>
              <h3>Learning Budget</h3>
              <p>Annual learning allowance for courses, books, and conferences of your choice</p>
            </div>
          </div>
        </div>
      </div>

      {/* Apply Modal */}
      {showApplyModal && selectedJob && (
        <div className={styles.modalOverlay} onClick={handleCloseModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.modalCloseBtn} onClick={handleCloseModal}>
              <i className="fas fa-times"></i>
            </button>
            
            <div className={styles.modalHeader}>
              <div className={styles.modalIcon}>
                <i className="fas fa-paper-plane"></i>
              </div>
              <h2>Apply for {selectedJob.title}</h2>
              <p>{selectedJob.department} • {selectedJob.location}</p>
            </div>

            <div className={styles.modalBody}>
              <div className={styles.modalInfo}>
                <div className={styles.modalInfoItem}>
                  <i className="fas fa-calendar-alt"></i>
                  <span>Closes: {new Date(selectedJob.closingDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                </div>
                <div className={styles.modalInfoItem}>
                  <i className="fas fa-users"></i>
                  <span>{selectedJob.applicants}+ applicants already applied</span>
                </div>
              </div>

              <p className={styles.modalText}>
                You will be redirected to Google Forms to complete your application. 
                Please ensure you have your updated resume ready before proceeding.
              </p>
            </div>

            <div className={styles.modalFooter}>
              <button className={styles.modalCancelBtn} onClick={handleCloseModal}>
                Cancel
              </button>
              <button 
                className={styles.modalConfirmBtn}
                onClick={() => openGoogleForm(selectedJob.googleFormUrl)}
              >
                <i className="fas fa-external-link-alt"></i>
                Continue to Google Form
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Careers;